import { render } from "./layout-horizontal.vue?vue&type=template&id=e6de1616"
import script from "./layout-horizontal.vue?vue&type=script&lang=js"
export * from "./layout-horizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__